import Vue from 'vue';
import Moment from 'moment-timezone';
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import { iaModal, iaModalHide } from '@/utils/ai';
import HTMLString from '@/utils/classes/HTMLString';
import { valueKeyFormat } from '@/utils/constants';
import { globalEventDispatcher, ShizenGlobalEvent } from '@/utils/event-dispatcher/global';

function IAAnalyser() {}
IAAnalyser.styles = {
  none: '',
  bad: 'color: #CD5E1E;',
  veryBad: 'color: #C83636;',
  awful: 'color: #C83636;font-weight: 700;',
};
IAAnalyser.healths = {
  good: { id: 0, color: 'green' },
  okay: { id: 1, color: 'yellow' },
  bad: { id: 2, color: 'orange' },
  veryBad: { id: 3, color: 'red' },
};
IAAnalyser.analysePlans = (app, plans) => {
  const planShortTermLimit = 48;
  // Data variables
  const ps = plans;
  const pLen = ps.length;
  let aLen;
  let p;
  let a;
  let planIsShortTerm;
  // Analysis variables
  let nShortTerm = 0;
  let nLongTerm = 0;
  let nActions = 0;
  let nLate = 0;
  const nForUser = {};
  const message = new HTMLString();
  for (let i = 0; i < pLen; i++) {
    p = ps[i];
    planIsShortTerm = p.actionDuration <= planShortTermLimit;
    if (planIsShortTerm) {
      nShortTerm += p.actions.length;
    } else {
      nLongTerm += p.actions.length;
    }
    aLen = p.actions.length;
    for (let j = 0; j < aLen; j++) {
      a = p.actions[j];
      if (!nForUser[`${a.leader}`]) {
        nForUser[`${a.leader}`] = 0;
      }
      nForUser[`${a.leader}`]++;

      const range = Moment.duration(Moment(a.deadline).diff(a.added));
      const diff = Moment.duration(Moment().diff(a.added));
      const perc = diff / range * 100;
      nLate += perc >= 100 && a.pdca < 4 ? 1 : 0;
    }
  }
  nActions = nShortTerm + nLongTerm;

  message.line(
    app.$t(
      'message.ACTIONS_DISTRIBUTION_STLT',
      { st: Number(nShortTerm * 100 / nActions).toFixed(1), lt: Number(nLongTerm * 100 / nActions).toFixed(1) },
    ),
  );
  if (nShortTerm < nLongTerm) {
    message.iaLine(app.$t('message.DAILY_MGT_ST_LT'));
  }
  // Unassigned actions
  if (nForUser['0'] > 0) {
    message.br().line(
      app.$t('message.N_UNASSIGNED_ACTIONS',
        { nb: nForUser['0'] }),
      { cStyle: IAAnalyser.styles.veryBad },
    );
  }
  // User has more than 60% actions in the plans
  for (let i = 0, uLen = app.App.thisTeamUsers.length; i < uLen; i++) {
    const u = app.App.thisTeamUsers[i];
    if (nForUser[`${u.id}`] > nActions * 0.6) {
      message.line(app.$t('message.USER_MORE_THAN_60PERC_ACTIONS', { user: `${u.firstName} ${u.lastName}` }))
        .iaLine(app.$t('message.EVERYONE_SHOULD_PARTICIPATE'));
    }
  }
  // Late actions
  message.br().line(app.$tc('message.N_LATE_ACTIONS', nLate, { nb: nLate }));
  if (nLate > 0) {
    message.iaLine(app.$t('message.IA_HAVE_YOU_TALKED_ABOUT_IT'));
  }
  return message.toString();
};

IAAnalyser.analyseProblems = (comp, callback, problems) => {
  function doAnalyse(pbs) {
    const pbsLength = pbs.length;
    const timeLimit = Moment().subtract(30, 'days');
    const monthBefore = timeLimit.clone().subtract(30, 'days');
    comp.$http.get('/server/team/parameters').then(({ data: d }) => {
      if (comp._isDestroyed) {
        return;
      }
      const criticImpact = d.dbProblemsMinImpact;
      let nCritic = 0;
      let nPendingCritic = 0;
      let nProblems = 0;
      let nProblemPrevMonth = 0;
      let latestProblemCreation = timeLimit.clone();
      for (let i = 0; i < pbsLength; i++) {
        const pb = pbs[i];
        if (timeLimit.isAfter(pb.created)) {
          if (monthBefore.isBefore(pb.created)) {
            // PRev month problems
            nProblemPrevMonth++;
          }
          continue;
        }
        // This month problems
        if (latestProblemCreation.isBefore(pb.created)) {
          latestProblemCreation = Moment(pb.created);
        }
        nProblems++;
        if (pb.impact >= criticImpact) {
          nCritic++;
          if (Number(pb.state) === 1) {
            nPendingCritic++;
          }
        }
      }
      //
      const msg = new HTMLString();
      if (nProblems === 0) {
        msg.line(comp.$t('message.NO_PROBLEMS'));
      } else {
        if (nCritic === 0) {
          msg.line(comp.$t('message.NO_CRITICAL_PROBLEM'));
          msg.iaLine(comp.$t('message.IS_IMPACT_CORRECTLY_SET'));
        } else {
          const nIncludePending = comp.$tc('message.N_CRITICAL_PENDING_PROBLEM', nPendingCritic, { n: nPendingCritic });
          msg.line(comp.$tc('message.N_CRITICAL_PROBLEM', nCritic, { nb: nCritic }) + nIncludePending);
          if (nPendingCritic >= 1) {
            msg.iaLine(comp.$t('message.CRITICAL_PROBLEM_MUST_BE_RESOLVED'));
          }
        }
        msg.br().line(
          comp.$tc('message.N_PROBLEMS', nProblems, { nb: nProblems })
          + comp.$t('message.N_PROBLEM_MONTHS', { nbPrev: nProblemPrevMonth }),
        );
        if (nProblems > nProblemPrevMonth && nProblemPrevMonth > 0) {
          msg.line(comp.$t('message.N_PROBLEM_INCREASE', { nb: (nProblems * 100 / nProblemPrevMonth).toFixed(1) }));
        } else if (nProblemPrevMonth > nProblems && nProblems > 0) {
          msg.line(comp.$t('message.N_PROBLEM_DECREASE', { nb: (nProblemPrevMonth * 100 / nProblems).toFixed(1) }));
        }
        const nDaysWithoutPb = Moment().diff(latestProblemCreation, 'days');
        msg.br().line(comp.$t('message.NO_PROBLEMS_SINCE', { nDays: nDaysWithoutPb }));
        if (nDaysWithoutPb > 3) {
          msg.iaLine(comp.$t('message.DAILY_MGT_MEANS_DAILY_PROBLEMS'));
        }
      }
      callback(msg.toString());
    });
  }
  if (!problems) {
    comp.App.post('/server/problems/get.php', {}, (d) => {
      if (!Array.isArray(d)) {
        callback('');
      }
      doAnalyse(d);
    });
  } else {
    doAnalyse(problems);
  }
};

/**
 * Create an HTML message for the "Intelligent Assistant" from a set of indicator themes.
 * Also create a specific message for each indicator, by going through the last 30 days.
 * @param  {Array}   themes    Set of indicator themes
 * @param  {Moment}   endDate  Date from which 30 days will be subtracted
 * @param  {Function} callback Function to call once the processing is done
 */
IAAnalyser.analyseIndicators = (themes, endDate) => {
  let indicator;
  let nIssues = 0;
  let overallLongestStraight = 0;
  for (let i = 0, len = themes.length; i < len; i++) {
    for (let j = 0, jlen = themes[i].indicators.length; j < jlen; j++) {
      nIssues++;
      indicator = themes[i].indicators[j];
      const msg = new HTMLString(`<h3>${indicator.name}</h3><p>(${themes[i].name})</p>`);

      const settingsObjective = Number(indicator.objective);
      const objP = { objective: settingsObjective };
      const objIsMax = Number(indicator.objectiveIsMax) === 1;
      msg.line(objIsMax ? i18n.t('message.MAX_OBJECTIVE', objP) : i18n.t('message.MIN_OBJECTIVE', objP));

      const startDate = endDate.clone().subtract(30, 'd');
      const { inputValues, objectives } = indicator;
      // Calculate values outside range
      let outsideRange = 0;
      let inRange = 0;
      /* eslint-disable-next-line no-unused-vars */
      let unsetValues = 0;
      // Calculate a straight of bad values
      let straight = [];
      let longestStraight = [];
      const minDateFormat = i18n.t('minDateFormat');
      // Calculate the reccurrence of bad values over week days
      const weekDaysCountIn = [0, 0, 0, 0, 0, 0, 0];
      const weekDaysCountOut = [0, 0, 0, 0, 0, 0, 0];
      // Calculate values outside range within the last 10 days to determine the health of the indicator
      let count = 0;
      let nOutside10Days = 0;
      while (startDate.add(1, 'days').diff(endDate) <= 0) {
        const key = startDate.format(valueKeyFormat);
        const objective = objectives[key] === undefined ? settingsObjective : Number(objectives[key]);
        const valObj = inputValues[key];
        if (!valObj) {
          continue;
        }
        const val = valObj.value;
        if (val === null || isNaN(val)) {
          unsetValues++;
        } else if (Number(val) !== objective && (Number(val) > objective) === objIsMax) {
          outsideRange++;
          weekDaysCountOut[startDate.isoWeekday() - 1]++;
          straight.push(startDate.format(minDateFormat));
          if (count > 19) {
            nOutside10Days++;
          }
        } else {
          inRange++;
          weekDaysCountIn[startDate.isoWeekday() - 1]++;
          if (straight.length > longestStraight.length) {
            longestStraight = straight;
          }
          if (straight.length > overallLongestStraight) {
            overallLongestStraight = straight.length;
          }
          straight = [];
        }
        count++;
      }
      // If the last value is outside range, check straights one last time
      if (straight.length > longestStraight.length) {
        longestStraight = straight;
      }
      if (straight.length > overallLongestStraight) {
        overallLongestStraight = straight.length;
      }
      // Create a message to display
      const all = inRange + outsideRange;
      msg.line(i18n.t('message.OUTSIDE_OBJECTIVE', { in: all, out: outsideRange })).br();
      // Message about values outside of range within last 10 days
      if (nOutside10Days > 2) {
        const style = nOutside10Days > 3 ? IAAnalyser.styles.veryBad : IAAnalyser.styles.bad;
        msg.line(i18n.t('message.OUTSIDE_OBJECTIVE_10_DAYS', { out: nOutside10Days }), { cStyle: style }).br();
        msg.iaLine(i18n.t('message.WHAT_DO_BACK_OBJECTIVE')).br();
      }

      const reportAnchor = `reportAnchor${i}-${j}`;
      if (outsideRange > (all / 3)) {
        msg.iaLine(new HTMLString()
          .span(i18n.t('message.WHY_OUTSIDE_OBJECTIVE')).br()
          .span(i18n.t('message.IS_OBJECTIVE_RIGHT'))
          .br()
          .span(i18n.t('message.IS_OBJECTIVE_AMBITIOUS'))
          .br()
          .br()
          .toString());
      }

      if (longestStraight.length > 1) {
        let style = IAAnalyser.styles.none;
        if (longestStraight.length > 4) {
          style = IAAnalyser.styles.awful;
        } else if (longestStraight.length > 3) {
          style = IAAnalyser.styles.veryBad;
        } else if (longestStraight.length > 2) {
          style = IAAnalyser.styles.bad;
        }
        const rowMsg = i18n.t('message.NB_DAYS_IN_A_ROW_OUTSIDE', {
          nb: longestStraight.length,
          fromDate: longestStraight[0],
          toDate: longestStraight[longestStraight.length - 1],
        });
        msg.line(rowMsg, { cStyle: style }).br();
      }
      if (outsideRange > (all / 3)) {
        msg.iaLine(i18n.t('message.NEED_LINKED_PROBLEM'), { cId: reportAnchor }).br();
      }
      for (let k = 0; k < weekDaysCountOut.length; k++) {
        if (weekDaysCountOut[k] > 2) {
          msg
            .br()
            .span(i18n.t(`weekDays[${k}]`) + i18n.t('message.TWO_DOTS'), { cClass: 'legend' })
            .span(i18n.t(
              'message.OUTSIDE_OBJECTIVE',
              { in: weekDaysCountIn[k] + weekDaysCountOut[k], out: weekDaysCountOut[k] },
            ));
        }
      }
      indicator.message = msg;
      // Health
      // Red : More than 3 within 10 days or more than 9 within 30 days or (more than 2 and more than 7)
      // Orange : More than 2 (/10) or more than 7 (/30) or (more than 1 and more than 5)
      // Green : Less
      if (nOutside10Days > 3 || outsideRange > 9 || (nOutside10Days > 2 && outsideRange > 7)) {
        indicator.health = IAAnalyser.healths.veryBad;
      } else if (nOutside10Days > 2 || outsideRange > 7 || (nOutside10Days > 1 && outsideRange > 5)) {
        indicator.health = IAAnalyser.healths.bad;
      } else if (all < (outsideRange * 6) || longestStraight.length > 3) {
        indicator.health = IAAnalyser.healths.okay;
      } else {
        nIssues--;
        indicator.health = IAAnalyser.healths.good;
      }
    }
  }
  const msg = new HTMLString().line(i18n.tc('message.N_INDIC_ISSUES_FOUND', nIssues, { nb: nIssues }));
  if (nIssues) {
    msg.line(i18n.t('message.INDIC_ISSUES_CHECK_OUT'));
  }
  if (overallLongestStraight > 2) {
    msg.br().line(
      i18n.t('message.INDIC_LONGEST_STRAIGHT_OUTSIDE', { nb: overallLongestStraight }),
      { cStyle: 'font-style: italic' },
    );
  }
  return { msg: msg.toString(), themes };
};

IAAnalyser.displayIndicatorsAnalysis = (themes, tIndex, iIndex, preventFetchingNext) => {
  let theme;
  let indicator;
  while (typeof theme === 'undefined' || typeof indicator === 'undefined') {
    if (themes.length <= tIndex) {
      // Looped through all indicators
      return;
    }
    theme = themes[tIndex];
    if (theme.indicators.length <= iIndex) {
      tIndex++;
      iIndex = 0;
      if (preventFetchingNext) {
        return;
      }
    } else if (theme.indicators[iIndex].health !== IAAnalyser.healths.good) {
      indicator = theme.indicators[iIndex];
    } else {
      ++iIndex;
      if (preventFetchingNext) {
        return;
      }
    }
  }
  // Find related element and determine position
  const el = $(`.indicator-${tIndex}-${iIndex}`);
  const pageContent = $('#page-content');
  let pParam = { width: '70%', left: '15%' };
  if (el && el.width() < pageContent.width() / 2) {
    const left = el.offset().left - pageContent.offset().left;
    const right = pageContent.width() - el.width() - left;
    if (left > right) {
      pParam = { width: `${left - 40}px` };
    } else {
      pParam = { width: `${right}px`, right: '20px', left: 'auto' };
    }
    el.addClass('generic-border--cyan-border');
  }
  // Show bad indicator
  iaModalHide();
  iaModal(
    indicator.message.toString(),
    [
      {
        title: i18n.t('message.NEXT'),
        action() {
          IAAnalyser.displayIndicatorsAnalysis(themes, tIndex, ++iIndex);
        },
      },
      {
        title: i18n.t('message.REPORT_PROBLEM'),
        action() {
          globalEventDispatcher.dispatch(ShizenGlobalEvent.NEW_PROBLEM);
        },
        anchor: `reportAnchor${tIndex}-${iIndex}`,
      },
    ],
    pParam,
    'analyst',
    () => {
      if (el) {
        el.removeClass('generic-border--cyan-border');
      }
    },
  );
};

IAAnalyser.analyseProblemSheet = (comp) => {
  const pIndex = comp.$refs.dataSection.problemTrust;
  const cIndex = comp.$refs.causesSection.causesTrust * 100;
  const aIndex = comp.$refs.actionsSection.actionsTrust * 100;
  const btns = [];
  const msg = new HTMLString();
  msg.line(comp.$t('message.PROBLEM_TRUST_INDEX', { index: pIndex.toFixed(0) }));
  if (pIndex >= 65) {
    msg.iaLine(comp.$t('message.PROBLEM_WELL_DESCRIBED'));
  } else {
    msg.iaLine(comp.$t('message.IA_HOW_PROBLEM_MUST_BE_DESCRIBED'));
    msg.button(comp.$t('message.IMPROVE_PROBLEM_DECRIPTION'), { cId: 'fillProblem' }).br();
    btns.push({ action() { IAAnalyser.problemDescriptionGuide(comp, 0); }, anchor: 'fillProblem' });
  }
  msg.br().line(comp.$t('message.CAUSES_TRUST_INDEX', { index: cIndex.toFixed(0) }));
  if (cIndex >= 80) {
    msg.iaLine(comp.$t('message.CAUSES_ARE_TRUE_CAUSES'));
  } else {
    msg.iaLine(comp.$t('message.IA_WHAT_IS_TRUE_CAUSE'));
    msg.button(comp.$t('message.INCREASE_CAUSES_TRUST'), { cId: 'fillCauses' }).br();
    btns.push({ action() { IAAnalyser.problemCausesGuide(comp, 0); }, anchor: 'fillCauses' });
  }
  msg.br().line(comp.$t('message.ACTIONS_TRUST_INDEX', { index: aIndex.toFixed(0) }));
  if (aIndex >= 80) {
    msg.iaLine(comp.$t('message.ACTIONS_WELL_LINKED'));
  } else {
    msg.iaLine(comp.$t('message.IA_ACTIONS_SHOULD_BE_LINKED_TO_CAUSES'));
  }
  // Init guide data
  IAAnalyser.sheetGuideSteps = [
    {
      field: 'files',
      head: comp.$t('message.PICTURE'),
      title: comp.$t('message.PROBLEM_NEEDS_PICTURE'),
      elt: $('.picture-carousel').get(0),
      action() { $('.picture-carousel .picture-carousel__current-picture').trigger('click'); },
    }, {
      field: 'lWhat',
      head: comp.$t('message.WHAT'),
      title: comp.$t('message.IA_TEACH_WHAT'),
      elt: $('#sheet-id-0'),
      action() {
        $('#sheet-id-0').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-0 .textarea').focus(); });
      },
    }, {
      field: 'lWho',
      head: comp.$t('message.WHO'),
      title: comp.$t('message.IA_TEACH_WHO'),
      elt: $('#sheet-id-1'),
      action() {
        $('#sheet-id-1').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-1 .textarea').focus(); });
      },
    }, {
      field: 'lWhere',
      head: comp.$t('message.WHERE'),
      title: comp.$t('message.IA_TEACH_WHERE'),
      elt: $('#sheet-id-2'),
      action() {
        $('#sheet-id-2').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-2 .textarea').focus(); });
      },
    }, {
      field: 'lWhen',
      head: comp.$t('message.WHEN'),
      title: comp.$t('message.IA_TEACH_WHEN'),
      elt: $('#sheet-id-3'),
      action() {
        $('#sheet-id-3').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-3 .textarea').focus(); });
      },
    }, {
      field: 'lHow',
      head: comp.$t('message.HOW'),
      title: comp.$t('message.IA_TEACH_HOW'),
      elt: $('#sheet-id-4'),
      action() {
        $('#sheet-id-4').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-4 .textarea').focus(); });
      },
    }, {
      field: 'lHowMuch',
      head: comp.$t('message.HOW_MUCH'),
      title: comp.$t('message.IA_TEACH_HOWMUCH'),
      elt: $('#sheet-id-5'),
      action() {
        $('#sheet-id-5').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-5 .textarea').focus(); });
      },
    }, {
      field: 'lWhy',
      head: comp.$t('message.WHY'),
      title: comp.$t('message.IA_TEACH_WHY'),
      elt: $('#sheet-id-6'),
      action() {
        $('#sheet-id-6').trigger('click');
        Vue.nextTick(() => { $('#sheet-id-6 .textarea').focus(); });
      },
    }, {
      field: 'types',
      head: comp.$t('message.TYPE'),
      title: comp.$t('message.IA_TEACH_PROBLEM_TYPES'),
      elt: $('#sheet-id-7'),
      action() { $('#sheet-id-7').trigger('click'); },
    },
  ];
  return { msg: msg.br().toString(), btns };
};
/** Steps data array (ordered). Each item is related to a field on the problem sheet */
IAAnalyser.sheetGuideSteps = [];
/** Guide the user through each problem empty field to improve its description
@Param comp: Vue 'problemsheet' component
@Param step: IAAnalyser.sheetGuideSteps index */
IAAnalyser.problemDescriptionGuide = (comp, step) => {
  const nextStep = step + 1;
  if (step === 0) {
    comp.App.iaOverlay.hide();
  }
  const o = IAAnalyser.sheetGuideSteps[step];
  if (o) {
    if (comp.problem[o.field] && comp.problem[o.field].length && comp.problem[o.field] !== 0) {
      IAAnalyser.problemDescriptionGuide(comp, nextStep);
    } else {
      const msg = `<h3>${o.head}</h3><div>${o.title}</div>`;
      IAAnalyser.problemGuideModal(
        msg, o.elt, [
          { title: comp.$t('message.NEXT'), action() { IAAnalyser.problemDescriptionGuide(comp, nextStep); } },
          { title: comp.$t('message.EDIT'), action() { o.action(); } },
        ],
      );
    }
  }
};
/** Guide the user through each cause that has an issue */
IAAnalyser.problemCausesGuide = (comp, index) => {
  if (index === 0) {
    comp.App.iaOverlay.hide();
  }
  const cause = comp.causesInSheet[index];
  const ctId = `ps-add-cause-desc${index}`;
  const cpId = `ps-add-cause-pict${index}`;
  if (cause) {
    const causeItem = comp.$refs.causeItems[index];
    const causeTrustIndex = cause.isVerified;
    const hasText = cause.text !== '';
    const hasPictures = cause.files.length > 0;
    if (causeItem && typeof causeTrustIndex !== 'undefined') {
      const btns = []; const
        msg = new HTMLString();
      if (!hasText && !hasPictures) {
        // Cause is empty
        msg.line(comp.$t('message.IA_CAUSE_NEEDS_ANY'), { cId: ctId }).br().br();
      }
      // Check description
      if (!hasText) {
        msg.line(comp.$t('message.IA_CAUSE_NEEDS_DESC'), { cId: ctId }).br().br();
        btns.push({
          title: comp.$t('message.ADD_DESCRIPTION'),
          action: () => {
            $(causeItem.$refs.label).trigger('click');
            Vue.nextTick(() => {
              $(causeItem.$refs.label.$el).find('.textarea').focus();
            });
          },
          anchor: ctId,
        });
      }
      // Check picture
      if (!hasPictures) {
        msg.line(comp.$t('message.IA_CAUSE_NEEDS_PICTURE'), { cId: cpId }).br().br();
        btns.push({
          title: comp.$t('message.ADD_PICTURE'),
          action: causeItem.causePictureClick,
          anchor: cpId,
        });
      }
      // If anything wrong, display guide
      if (btns.length) {
        btns.push({ title: comp.$t('message.NEXT'), action() { IAAnalyser.problemCausesGuide(comp, index + 1); } });
        IAAnalyser.problemGuideModal(msg.toString(), causeItem.$el, btns, '2%');
      } else {
        IAAnalyser.problemCausesGuide(comp, index + 1);
      }
    }
  }
};
/** Display the modal and highlight an elt */
IAAnalyser.problemGuideModal = (msg, highlight, btns, leftOffset) => {
  const left = leftOffset || '34.5%';
  const $el = $(highlight);
  $el.addClass('ia-highlight');
  iaModal(msg, btns, { width: '31%', left, top: '50px', bottom: '50px' }, 'analyst', () => {
    if ($el) {
      $el.removeClass('ia-highlight');
    }
  });
};

export default IAAnalyser;
